import React from 'react';
import styles from './Status.module.scss';

const Status = ({ status, title, icon }) => {
    return (
        <span className={`${styles.status} ${styles[status]}`}>
            <i className={`${styles.icon} ${icon}`} />
            {title}
        </span>
    );
};

export default Status;
